<!-- View Sidebar Drawer -->
<app-side-drawer headerTitle="" elementId="notification">
  <div class="drawer-header bg-green px-3 py-4">
    <div class="form-wrapper__header d-flex justify-content-between">
      <h5 class="mb-0 text-white">Notifications</h5>
      <div class="click text-white">Clear all</div>
      <div class="d-flex align-items-center close-drawer click" #closeDrawer>
        <p class="mr-2 mb-0 text-white">Close</p>
        <svg
          fill="none"
          height="20"
          viewBox="0 0 20 20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.5139 0 10 0ZM10 18.2857C5.43136 18.2857 1.7143 14.5686 1.7143 10C1.7143 5.43136 5.43136 1.7143 10 1.7143C14.5686 1.7143 18.2857 5.43136 18.2857 10C18.2857 14.5686 14.5685 18.2857 10 18.2857Z"
            fill="#fff"
          ></path>
          <path
            d="M13.8694 6.131C13.5346 5.79618 12.9916 5.79618 12.6574 6.131L10 8.78872L7.34263 6.131C7.00781 5.79618 6.46545 5.79618 6.13063 6.131C5.7958 6.46583 5.7958 7.00818 6.13063 7.34301L8.788 10.0006L6.13051 12.6583C5.79569 12.9931 5.79569 13.5355 6.13051 13.8703C6.29787 14.0377 6.51722 14.1215 6.73657 14.1215C6.95593 14.1215 7.17551 14.0378 7.34263 13.8703L10 11.2127L12.6574 13.8703C12.8247 14.0377 13.0441 14.1215 13.2634 14.1215C13.4828 14.1215 13.702 14.0378 13.8695 13.8703C14.2043 13.5355 14.2043 12.9931 13.8695 12.6583L11.212 10.0007L13.8694 7.34312C14.2042 7.0083 14.2042 6.46583 13.8694 6.131Z"
            fill="#fff"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  <div class="drawer-body">
    <div class="mt-4 bg-white">
      <div *ngIf="isLoading" class="loading-indicator">
        <mat-spinner diameter="20"></mat-spinner>
      </div>

      <p *ngIf="unreadNotifications.length == 0">
        There are currently no notifications at the moment. You will be notified
        as soon as u get one
      </p>
      <div class="px-3" *ngFor="let notification of unreadNotifications">
        <div class="d-flex justify-content-between">
          <div class="d-flex click" (click)="view(notification)">
            <div class="check mr-3" *ngIf="notification?.isRead">
              <i class="fa fa-check"></i>
            </div>
            <div class="dot mr-3" *ngIf="!notification?.isRead">
              <i class="fa fa-dot-circle-o"></i>
            </div>
            <div class="font14">{{ notification?.content }}</div>
          </div>
        </div>

        <hr />
      </div>
    </div>
    <div class="d-flex justify-content-center sm-flex-column">
      <pagination-controls
        id="listing_pagination"
        (pageChange)="navigatePage($event)"
      ></pagination-controls>
    </div>
  </div>
</app-side-drawer>
